/* Response Time CSS */

export default theme => ({
    root: {
      fontFamily: "Impact,Charcoal,sans-serif"

    },
    refreshButton: {
      margin: -theme.spacing(2)
    },
    textWhite:{
      color:"white",
      fill:"white"
    },
    backGrey:{
      backgroundColor:"#525252"
    },
    backWhite:{
      backgroundColor:"white",
      fontWeight: "bold"
    },
    bWhite:{
      backgroundColor:"white",
    },
    chart: {
      width: '500px',
      margin: '0 auto',
      //height: '300px',
      textAlign: 'center',
    },
    header: {
      height: '40px',
      color: theme.palette.text.secondary
    },
    stats: {
      marginTop: theme.spacing(2),
      display: 'flex',
      justifyContent: 'center'
    },
    portletFooter: {
      display: 'flex',
      justifyContent: 'space-between'
    },
    details: {
      
      padding: '50px',
      flex: '1 100%',
      marginTop: '50px',
      marginBottom: '50px',
      marginRight: '50px',
      marginLeft: '50px'
    },
  
  });
  
  